const state = {
  snackbar: false,
  snackbar_color: "",
  snackbar_text: "",
  snackbar_timeout: 1000,
}

const actions = {
  updateSnackbar({ commit }, payload) {
    commit('updateSnackbar', payload)
  },
  updateSnackbarColor({ commit }, payload) {
    commit('updateSnackbarColor', payload)
  },
  updateSnackbarText({ commit }, payload) {
    commit('updateSnackbarText', payload)
  },
  updateSnackbarTimeout({ commit }, payload) {
    commit('updateSnackbarTimeout', payload)
  },
}

const getters = {
  getSnackbar: state => {
    return state.snackbar
  },
  getSnackbarColor: state => {
    return state.snackbar_color
  },
  getSnackbarText: state => {
    return state.snackbar_text
  },
  getSnackbarTimeout: state => {
    return state.snackbar_timeout
  },
}

const mutations = {
  updateSnackbar: (state, payload) => {
    state.snackbar = payload.snackbar;
  },
  updateSnackbarColor: (state, payload) => {
    state.snackbar_color = payload.snackbar_color;
  },
  updateSnackbarText: (state, payload) => {
    state.snackbar_text = payload.snackbar_text;
  },
  updateSnackbarTimeout: (state, payload) => {
    state.snackbar_timeout = payload.snackbar_timeout;
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}